import React, { Component } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={13}
      ref={props.onMapLoad}
      onClick={props.onClick}     
      defaultCenter={{ lat: props.lat, lng: props.lng }}
      defaultOptions={{
        scrollwheel: false,
        zoomControl: true,
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 }
            ]
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }]
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }]
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }]
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }]
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
          },
          { featureType: "poi.park", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "on" }]
          },
          { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "simplified" }]
          }
        ]
      }}
    >
      <Marker position={{ lat: props.lat, lng: props.lng }} />
    </GoogleMap>
  ))
);

class Maps extends Component {
  componentWillReceiveProps(newProps) {
    this.panIfNeed(newProps);  
  }

  panIfNeed({lng, lat}) {
    if (!this._map) return;
    if (!lat || !lng) return;

    const bounds = this._map.getBounds();

    if (bounds) {
      const NorthEast = bounds.getNorthEast();
      const SouthWest = bounds.getSouthWest();

      const north = NorthEast.lat();
      const east = NorthEast.lng();
      const south = SouthWest.lat();
      const west = SouthWest.lng();

      const inBounds = (lat > south && lat < north) && (lng > west && lng < east);

      if (!inBounds) {
        this._map.panTo({lat, lng});
      }
    }
  }

  handleMapClick(event) {
    const lat = Number(event.latLng.lat());
    const lng = Number(event.latLng.lng());
    const { onChange } = this.props;
    if (onChange) { onChange({lng, lat}) };
  }

  render() {
    return (
      <CustomSkinMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAKg1jX1gS4mYZQw2v2fwtaUfwzW02CHJM"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: this.props.height }} />}
        mapElement={<div style={{ height: `100%` }} />}
        onMapLoad={ref => this._map = ref}
        onClick={e => this.handleMapClick(e)}
        lat={this.props.lat}
        lng={this.props.lng}
      />
    );
  }
}

export default Maps;
